import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IceButton from "../../components/Button";


export default function DialogDeleteMap(props: any) {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)
    let {open, setOpen, keyDataSet, setSaveStatus} = props

    function handleDelete() {

        fetch(`${serverIP}/deletemap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(keyDataSet),
        }).then(res => res.json())
            .then((data) => {
                if (data.code === 200) {
                    setSaveStatus(306)
                }
                // console.log(data)
            })

        setOpen(false)    // a dialog must be closed anyway after Save is clicked
    }

    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Delete Mapping</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    Please, confirm deleting the mapping. <br/>
                    All rules will be deleted.
                </DialogContentText>

            </DialogContent>

            <DialogActions>
                <IceButton type="delete" text="Delete" onclick={handleDelete} />
                <IceButton type="secondary" text="Cancel" onclick={() => setOpen(false)} />
            </DialogActions>
        </Dialog>
    );
}